




import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import UseCardFormIframe from './useCardformIframe';
import {
  CoinflowCardNumberInputProps,
  CoinflowCardTokenResponse,
  TokenExCardNumberIframeId,
} from '../lib/common';

@Component
export default class CoinflowCardNumberInput extends Mixins(UseCardFormIframe) {
  @Prop({ required: true, type: Object }) args!: CoinflowCardNumberInputProps;

  tokenExIframe: any = null;
  tokenExScriptLoaded: boolean = false;
  iframeId: string = TokenExCardNumberIframeId;

  async getToken(): Promise<CoinflowCardTokenResponse> {
    if (!this.tokenExIframe) throw new Error('Unable to get token');
    return this.tokenExIframe.tokenize();
  }

  css() {
    return JSON.stringify(this.args.css);
  }

  @Watch('tokenExScriptLoaded')
  onTokenExScriptLoadedChange(newVal: boolean) {
    if (newVal) {
      this.initializeTokenExIframe({
        css: this.css(),
        debug: this.args.debug,
        origins: this.args.origins,
      });
    }
  }
}
